<template>
  <div class="col-12 card">
    <div class="card-header">
      <h3 class="card-title">处理结果</h3>
    </div>
    <div class="card-body">
      <div style="text-align: center;padding-top: 20px;">
        <img src="@/assets/images/cljg.png" style="width: 320px;">
      </div>
      <div style="text-align: center;margin-top: 80px;">
        <p>
          尊敬的企业用户您好，您的资料审核未通过，请修改后重新提交。
        </p>
        <router-link to="/enterprise/enterprise_info_view">
          <button class="btn btn-twitter" style="margin-top: 20px;padding-left: 20px;padding-right: 20px;background-color:#90c31f;border:none;">去修改</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "submitSuccess",

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/SubmitFail.vue